// extracted by mini-css-extract-plugin
export default {"container":"bIoGkz","content":"Ev2MC6","inner":"_KsPHr","link":"QuVjdj","heading":"OpPkAv","description":"bWshdQ"};